import { Outlet } from 'react-router'
import { Card } from '#app/components/ui/card.tsx'

const AuthLayout = () => {
	return (
		<div className="bg-muted flex h-dvh flex-col justify-between gap-8">
			<Card className="bg-background mx-auto my-auto items-center gap-10 py-12">
				<div className="flex flex-col items-center gap-4 px-6">
					<img
						src="/img/logo.png"
						alt="Logo of GOS"
						className="size-40 p-2 dark:rounded-full dark:bg-white"
					/>
					<h1 className="text-secondary-foreground text-xl font-semibold">
						Import Permit Management System
					</h1>

					<hr className="w-full bg-gray-500" />
				</div>

				<Outlet />
			</Card>
			<div className="flex flex-col items-center pb-6 text-xs text-gray-400">
				<p>Designed and Developed by Excise Department</p>
				<p>Government of Sikkim</p>
			</div>
		</div>
	)
}

export default AuthLayout
